import React from "react";
import { ActiveClientsSection } from "./active-clients-section";
import { SubscriptionOverviewSection } from "./subscription-overview-section";
import styles from "./index.module.scss";

export const SubscriptionOverviewChartBlock = ({ 
  activeMSPAccounts, 
  statsConfig, 
  isDistributor = true,
  distributorsData,
  mspData,
}) => {
  
  return (
    <div className={styles.frame}>
      <SubscriptionOverviewSection 
        statsConfig={statsConfig} 
        isDistributor={isDistributor}
        distributorsData={distributorsData}
        />
      <ActiveClientsSection 
        activeMSPAccounts={activeMSPAccounts} 
        isV2={true}
        mspData={mspData}
        isDistributor={isDistributor}
        />
    </div>
  );
};